import { useStyles } from '@team-griffin/stylr';
import cssSides, { Side } from '@team-griffin/css-sides';
import longhand from '@team-griffin/css-longhand';
import { gu2px, useTheme, Colorway } from '@uds/theme-utils';
import { content } from '@ux/type-size';
import { getContrastColor, getTitleColor } from 'presentation/utils/colorway';
import rgba from 'presentation/utils/rgba';

export default ({
  colorway,
  selected,
  hover,
}: {
  colorway: Colorway;
  selected: boolean | undefined;
  hover: boolean;
}) => {
  const { theme } = useTheme();
  const { spacing, typography } = theme;
  const contrastColor = getContrastColor(theme, colorway);

  return useStyles(
    {
      default: {
        root: {
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          position: 'relative',
          textAlign: 'center',
          fontFamily: typography.display,
          ...content(),
          color: getTitleColor(theme, colorway),
          width: '100%',
          borderWidth: 0,
          outline: 0,
          cursor: 'pointer',
          paddingTop: gu2px(2, spacing),
          paddingBottom: gu2px(2, spacing),
          ...cssSides('padding', Side.X, 0),
          ...longhand('borderBottom', {
            width: 4,
            style: 'solid',
            color: 'transparent',
          }),
          backgroundColor: 'transparent',
          transition: 'border-bottom-color 0.3s ease-in-out',
          textDecoration: 'none',
        },
        text: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        icon: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: gu2px(3, spacing),
          height: gu2px(3, spacing),
          color: contrastColor,
          marginRight: gu2px(1, spacing),
        },
        image: {
          width: gu2px(3, spacing),
          height: gu2px(3, spacing),
          minWidth: gu2px(3, spacing),
          objectFit: 'cover',
          objectPosition: 'center',
        },
        badge: {
          marginLeft: gu2px(1, spacing),
        },
      },

      selected: {
        root: {
          borderBottomColor: contrastColor,
        },
      },

      hover: {
        root: {
          borderBottomColor: rgba(getContrastColor(theme, colorway), 0.9),
        },
      },
    },
    [{ hover }, { colorway }, { selected }],
  );
};
